/* RESPONSIBLE TEAM: team-inbox-experience */
export const VISIBILITY_FILTER_TYPE = {
  ANY: 'any',
  TEAM: 'team',
  SAVED_REPLY_TYPE: 'saved_reply_type',
};
